import { render, staticRenderFns } from "./AdminStandardEdit.vue?vue&type=template&id=004f5d67"
import script from "./AdminStandardEdit.vue?vue&type=script&lang=js"
export * from "./AdminStandardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports